import { FunctionComponent, useState, useRef, useEffect, MouseEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons';
import { faTrash, faArrowsRotate } from '@fortawesome/pro-regular-svg-icons';
import styles from './NodeMenu.module.scss';

interface Props {
    onDelete: () => void;
    onFlipSplit?: () => void;
}

const NodeMenu: FunctionComponent<Props> = ({ onDelete, onFlipSplit }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    // Close on outside click
    useEffect(() => {
        if (!open) return;
        const handle = (e: globalThis.MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handle);
        return () => document.removeEventListener('mousedown', handle);
    }, [open]);

    const handleToggle = (e: MouseEvent) => {
        e.stopPropagation();
        setOpen(prev => !prev);
    };

    const handleDelete = (e: MouseEvent) => {
        e.stopPropagation();
        setOpen(false);
        onDelete();
    };

    const handleFlipSplit = (e: MouseEvent) => {
        e.stopPropagation();
        setOpen(false);
        onFlipSplit?.();
    };

    return (
        <div
            ref={ref}
            className={styles.root}
        >
            <button
                type="button"
                className={styles.trigger}
                onClick={handleToggle}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>

            {open && (
                <div className={styles.dropdown}>
                    {onFlipSplit && (
                        <button
                            type="button"
                            className={styles.itemNeutral}
                            onClick={handleFlipSplit}
                        >
                            <FontAwesomeIcon
                                icon={faArrowsRotate}
                                className={styles.itemIcon}
                            />
                            Flip Split
                        </button>
                    )}
                    <button
                        type="button"
                        className={styles.item}
                        onClick={handleDelete}
                    >
                        <FontAwesomeIcon
                            icon={faTrash}
                            className={styles.itemIcon}
                        />
                        Delete
                    </button>
                </div>
            )}
        </div>
    );
};

export default NodeMenu;
